import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {EmployeeService} from '../../../../../employee.service';
import {NbDialogRef, NbDialogService} from '@nebular/theme';
import {SasisopaService} from '../../../../../services/sasisopa.service';
import {
  EmergencyPlanningFormComponent,
} from '../../emergency-planning/emergency-planning-form/emergency-planning-form.component';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';

@Component({
  selector: 'ngx-brigades-form',
  templateUrl: './brigades-form.component.html',
  styleUrls: ['./brigades-form.component.scss'],
})
export class BrigadesFormComponent implements OnInit {
  @Input() stationId: string;
  @Input() action: string;
  @Input() infoEdit: any;
  @ViewChild(SignaturePad, { static: false }) signaturePad: SignaturePad;
  signaturePadOptions: Object;
  loading = false;
  employees = [];
  showSignaturePad = false;
  data: any = {
    name: '',
    role: '',
    type: '',
    authority: '',
    responsibility: '',
    signature: '',
  };

  constructor(
    private employeeService: EmployeeService,
    private dialogService: NbDialogService,
    private sasisopaService: SasisopaService,
    protected ref: NbDialogRef<EmergencyPlanningFormComponent>,
  ) {
    const width = document.documentElement.clientWidth * .36;
    this.signaturePadOptions = {
      'minWidth': 0.8,
      maxWidth: 1,
      'backgroundColor': 'RGBA(245, 247, 249, 1.00)',
      'canvasWidth': width,
    };
  }

  async ngOnInit() {
    this.loading = true;
    if (this.action === 'edit') {
      this.stationId = this.infoEdit.station_id;
      this.data.name = this.infoEdit.name;
      this.data.role = this.infoEdit.role;
      this.data.type = this.infoEdit.type;
      this.data.authority = this.infoEdit.authority;
      this.data.responsibility = this.infoEdit.responsibility;
      this.data.signature = this.infoEdit.signature;
      this.showSignaturePad = false;
    } else {
      this.showSignaturePad = true;
    }
    await this.checkIfCreateOrEdit();
    this.loading = false;
  }

  clearSignature() {
    this.signaturePad.clear();
  }

  editSignature() {
    this.showSignaturePad = true;
    // Wait for the pad to be visible before setting data
    setTimeout(() => {
      if (this.data.signature) {
        this.signaturePad.fromDataURL(this.data.signature);
      }
    }, 100);
  }

  handleSubmit() {
    if (this.showSignaturePad) {
      this.data.signature = this.signaturePad.toDataURL();
    }
    if (this.action === 'edit') {
      this.edit();
    } else {
      this.store();
    }
  }

  async store() {
    this.data.station_id = this.stationId;
    this.loading = true;
    const [error] = await this.sasisopaService.createBrigade(this.data);
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    this.loading = false;
    await this.alert('Formato creado con éxito', 'success');
    this.ref.close(true);
  }

  async edit() {
    this.loading = true;
    this.data.station_id = this.stationId;
    const [error] = await this.sasisopaService.editBrigade(this.infoEdit.id, this.data);
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    this.loading = false;
    await this.alert('Formato editado con éxito', 'success');
    this.ref.close(true);
  }

  alert(title: string = '', type: SweetAlertIcon = 'success', text: string = '') {
    return Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  async checkIfCreateOrEdit() {
    if (this.action === 'edit') {
      this.data.name = this.infoEdit.name;
      this.data.phone = this.infoEdit.phone;
    }
  }
}
